import { render, staticRenderFns } from "./StaffTableKYCTooltip.vue?vue&type=template&id=39da7300&"
import script from "./StaffTableKYCTooltip.vue?vue&type=script&lang=js&"
export * from "./StaffTableKYCTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports